module.exports = __webpack_public_path__ + "img/profitability8.4b590042.png";